define(
    'viewmodels/secured/libraries/create/fromFolder/wizard',[
        "viewmodels/ViewModel",
        "providers/dataprovider",

        "viewmodels/secured/libraries/create/fromFolder/select/select"
    ],
    function (ViewModel, dataProvider,
        step1
        ) {

        var vm = new ViewModel(
        {
            step1: step1,
            step2: null,
            step3: null,
            step4: null
        });

        vm.activate = function () {
        }

        return vm;
    }
);
